import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../../styles";
import { rem } from "../../../utils";
const StyledFooterMenuAnchor = styled.a `
  color: ${Colors.GRAY_DARKEST};
  display: block;
  padding: ${rem(24)} 0 ${rem(9)};
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:hover,
  &:focus {
    color: ${Colors.GRAY_DARK};
    border-bottom-color: ${Colors.GRAY_DARK};
  }
`;
export const FooterMenuItem = ({ navigationItem, LinkRendererComponent, }) => (React.createElement(LinkRendererComponent, { AnchorElement: StyledFooterMenuAnchor, href: navigationItem.href }, navigationItem.title));
export default FooterMenuItem;
//# sourceMappingURL=index.js.map